import personService from "services/maintenance/personService";
import { Person2Outlined } from "@mui/icons-material";

const registerUserResource = {
    title: "Employees",
    singular: "Employees",
    displayField: "fullName",
    pageIcon: Person2Outlined,

    service: personService,

    columns: [
        {
            field: "fullName",
            header: "Employee Name"
        }
    ],

    fields: [
        {
            name: "fullName",
            label: "Employee Name",
            type: "text",
            required: true,
            unique: true
        }
    ],
    searchFields: ["fullName"]
};

export default registerUserResource;
